import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@els/els-react--checkbox';
import { ButtonWithIcon } from '@els/els-react--button';

function HeatmapSettingsDialogFooter({ disabled, alwaysShowSettings, setAlwaysShowSettings, applySettings }) {
  return (
    <div className="heatmap-settings-dialog__footer">
      <Checkbox
        label="Always show settings"
        onChange={setAlwaysShowSettings}
        data-e2e="heatmap-settings-always-show-settings"
        checked={alwaysShowSettings || false}
        className="heatmap-settings-dialog__checkbox"
      />
      <ButtonWithIcon
        type="primary"
        sprite="ChevronRight"
        iconRight
        data-e2e="heatmap-settings-apply-button"
        onClick={applySettings}
        disabled={disabled}
        className="e2e-heatmap-settings-apply">
        Apply
      </ButtonWithIcon>
    </div>
  );
}

HeatmapSettingsDialogFooter.defaultProps = {
  setAlwaysShowSettings: () => {},
  applySettings: () => {},
};

HeatmapSettingsDialogFooter.propTypes = {
  disabled: PropTypes.bool,
  alwaysShowSettings: PropTypes.bool,
  setAlwaysShowSettings: PropTypes.func,
  applySettings: PropTypes.func,
};

export default HeatmapSettingsDialogFooter;
